import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getOrderClaimForm } from 'domains/order/Order.store';
import { getTextMandatory, isHidden } from 'pages/MyOrdersPage/OrderClaims/claimForm.utils';
import { getAttachmentTitleLabel } from 'pages/MyOrdersPage/OrderClaims/claimFormData';
import { makeKey, RULES_DATA } from 'pages/MyOrdersPage/OrderClaims/claimFormRulesData';
import ClaimsFormAttachFiles from 'pages/MyOrdersPage/OrderClaims/ClaimsFormAttachFiles';
import { Text } from 'UI';

const OtherSection = () => {
  const { t } = useTranslation();
  const claimForm = useSelector(getOrderClaimForm);
  const rulesData =
    RULES_DATA[makeKey({ formType: claimForm.formType, reason: claimForm.reason, option: claimForm.option })];

  const allSectionFields = [rulesData?.attachments];

  const isOtherSectionHidden = allSectionFields.every((field) => isHidden(field));

  if (isOtherSectionHidden) {
    return null;
  }

  return (
    <>
      <Text type="heading3" disableGutter noWrap>
        {getTextMandatory(getAttachmentTitleLabel(t, claimForm.reason, claimForm.option), rulesData?.attachments)}
      </Text>
      {!isHidden(rulesData?.attachments) && <ClaimsFormAttachFiles />}
    </>
  );
};

export default OtherSection;
